import React, { Component, StrictMode, useEffect } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";
import DateFormater from '../../chat/Component/DateFormater';
import { LinkItUrl } from 'react-linkify-it';

const SystemMessage = ({message}) => {
  
  const dispatch = useDispatch();

  return (
    <div className={"kil-chat-widget-conversation-message system"}>
      <LinkItUrl>
        {message.message}
      </LinkItUrl>
    </div>
  );
}

export default SystemMessage;